// If we add to here, please also add to getProviderEnabledTeams in server/src/utils/coverage-monitor.ts
export enum Provider {
  COMMENTSOLD = "commentsold",
  SHOPIFY = "shopify",
  COMMERCE_CLOUD = "commerce-cloud",
  BIGCOMMERCE = "bigcommerce",
  NETSUITE = "netsuite",
  MANUAL = "manual",
  TIKTOK = "tiktok",
  AMAZON = "amazon",
  WALMART = "walmart",
  EBAY = "ebay",
  APPAREL_MAGIC = "apparel-magic",
  REDO_MARKETPLACE = "redo-marketplace",
  SFOM = "sfom",
  AIMS360 = "aims360",
  CIN7_OMNI = "cin7-omni",
  CIN7_CORE = "cin7-core",
  REDO_API = "redo-api", // See the OrdersApi integration (used by Porsche)
  CUSTOM_RETURN_INTEGRATION = "custom-return-integration",
  REDO = "redo", // Redo native checkout (agentic commerce)
  FAIRE = "faire",
  WOOCOMMERCE = "woocommerce",
  WAYFAIR = "wayfair",
  BRIGHTPEARL = "brightpearl",
  LINNWORKS = "linnworks",
  TEMU = "temu",
}
